import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect
} from 'vue-search-select';
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import download from 'downloadjs';
import Multiselect from 'vue-multiselect';
export default {
	name: 'inscan-shortage-shipment',
	components: {
		VueElementLoading,
		BasicSelect,
    DatePicker,
		Paginate,
		download,
		Multiselect
	},
	props: [],
	data() {
		return {
			isLoading: false,

      showBagTable:false,
      ConnectionIDError:'',
      vehicleNoError:'',
      thcNoError:'',
      fromdate:'',
      todate:'',
      toDateError:'',
      fromDateError:'',
      csmidradio: '',
      thcNo: '',
      vehicleNo: '',
      connectionDetails:[],
      checkedType:'bagNo',

			listHubZoneData: [],
			listHubZoneObjDataFlt1: {
        value: "",
        text: ""
      },
			hubzoneidflt1:'',
			listSourceHubNameListForFilter:[],
			listSourceHubNameDataObj3: {
				value: "",
				text: ""
			},
			HubZoneErrorFlg:0,
			sourceHubId:'',
			sourceHubIdFlg:'',
			listHubZoneObjDataFlt2: {
				value: "",
				text: ""
			},
			hubzoneidflt2:'',
			listDestHubNameListForFilter:[],
			listSourceHubNameDataObj2: {
				value: "",
				text: "",
			},
			DesHubID:'',
			DesHubIDFlg:0,
			HubZoneErrorFlgForDest:'',
			shippingId:'',
			shippingIdError:'',
			shipmentStatusArray:[{
				value: 1,
				text: "InScan",
			},
			{
				value: 2,
				text: "BagIn",
			},
			{
				value: 3,
				text: "OutScan",
			},
			{
				value: 4,
				text: "PendingOutScan",
			},
			{
				value: 5,
				text: "Scheduled"
			},
			{
				value: 6,
				text: "PrintDone"
			},
			{
				value: 7,
				text: "Handover"
			},
			{
				value: 8,
				text: "Delivered"
			},
			{
				value: 9,
				text: "Overage"
			}],
			shipmentStatusError:'',
			shipmentStatus:'',
			selectedShipmentStatus: {
				value: "",
				text: ""
			},
			hoursError:'',
			hours:'',
			comparsionArray:[{
				value: 1,
				text: "<",
			},
			{
				value: 2,
				text: ">",
			},
			{
				value: 3,
				text: "=",
			}
		],
		sign:'',
		signError:'',
		selectedComprator: {
			value: "",
			text: ""
		},
		bagNo:'',
		bagStatusArray:[{
			value: 1,
			text: "BagOpen"
		},
		{
			value: 2,
			text: "BagClosed"
		},
		{
			value: 3,
			text: "Invalid"
		},
		{
			value: 4,
			text: "InScan"
		},
		{
			value: 5,
			text: "OutScan"
		},
		{
			value: 6,
			text: "Scheduled"
		},
		{
			value: 7,
			text: "Handover"
		},
		{
			value: 8,
			text: "Delivered"
		},
		{
			value: 9,
			text: "PendingOutScan"
		},
		{
			value: 10,
			text: "PrintDone"
		},
		{
			value: 11,
			text: "Overage"
		}
	],
	selectedbagStatus: {
		value: "",
		text: ""
	},
	bagStatus:'',
	bagStausError:'',
	bagNo:'',
	shipmentResultData:[],
	checkvalidation:0,
	bagNoError:'',
	totalRows:0,
	pageNo: 0,
	limit: 10,
	bagDetails:[],
	pageCount: 0,
	bagStatusId:'',
	csvFields: [],
	bagDetailsForCsv:[],
	shipmentDetails:[],
	pageNoForShipment:1,
	limitForShipment:10,
	showShipmentTable:false,
	shipmentDetailsForCsv:[],
	totalBags:'',
	totalShipments:'',
	todaysDate:new Date(),
	validDateRange:'',
	validDateRangeFrom:'',
	hublist:[],
	DesHubIDArr:[],
	sourceHubIdArr:[]

		}
	},
	computed: {},
	mounted() {
		var userTokenEncrypt = window.localStorage.getItem('userToken')
		var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
		var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
		this.token = JSON.parse(userToken)
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.hubid = userdetail[0].HubId[0];
		this.createdbyemail = userdetail[0].email;
		this.getHubZoneData();
		this.getHubList();
	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
			return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	methods: {
		checkToDate() {
			var date1 = new Date(this.fromdate);
			date1.setDate(date1.getDate() + 14)
			if(date1>=this.todaysDate){
				this.validDateRange = this.todaysDate
			}else{
				this.validDateRange = date1
			}
		},
		checkFromDate() {
			var date2 = new Date(this.todate);
			date2.setDate(date2.getDate() - 14)
			this.validDateRangeFrom = date2
		},
		getHubList() {
			this.hublist = []
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					var HubDetails = result.data.ResponseData
					for (var i = 0; i < HubDetails.length; i++) {
						this.hublist.push({
							"value": HubDetails[i].HubID,
							"text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
						})
					}
				}, error => {
					console.error(error)
				})
		},

		selectBagStatus(data){
			this.selectedbagStatus=data
			this.bagStatus=data.text
			this.bagStatusId=data.value
		},
		selectcomprator(data){
			this.selectedComprator=data
			this.sign=data.text
		},
		selectShipmentType(data){
			this.selectedShipmentStatus=data
			this.shipmentStatus=data.text
		},
		getDestHubNameListForFilter() {
      this.hubLoading = 'Loading Hub...'
      this.listDestHubNameListForFilter = [];
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        hubZoneId: this.hubzoneidflt2
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          var listDestHubNameListForFilter = result.data.ResponseData;
          for (i = 0; i < listDestHubNameListForFilter.length; i++) {
            this.listDestHubNameListForFilter.push({
              value: listDestHubNameListForFilter[i].HubID,
              text: listDestHubNameListForFilter[i].HubCode + ' - ' + listDestHubNameListForFilter[i].HubName + ' (' + listDestHubNameListForFilter[i].HubID + ')',
              text1: listDestHubNameListForFilter[i].HubName,
              hubcode: listDestHubNameListForFilter[i].HubCode
            })
          }
        }, error => {
          console.error(error)
        })
    },
		selectedSourceHubName2(selectedData) {
			this.listSourceHubNameDataObj2 = selectedData
			this.DesHubID = selectedData.value;
		},
		selectedHubZoneFlt2(hubData) {
			this.DesHubIDArr=[]
			this.DesHubID=''
			this.listHubZoneObjDataFlt2 = hubData
			this.hubzoneidflt2 = hubData.value;
			if (this.hubzoneidflt2 != undefined) {
				this.getDestHubNameListForFilter(this.hubzoneidflt2)
			}
		},
		selectedSourceHubName3(selectedData) {
			this.searchHubID = ''
			this.isSearchHubErr = 0;
			this.SearchHubErr = ''
			this.listSourceHubNameDataObj3 = selectedData
			// this.HubName = selectedData.text;
			this.sourceHubId = selectedData.value;

			if (this.sourceHubId == '' || this.sourceHubId == undefined) {
				this.isSearchHubErr = '1',
					this.SearchHubErr = 'The SourceHubName field is required.'
			}
		},
		getSourceHubNameListForFilter() {
			this.hubLoading = 'Loading Hub...'
			this.listSourceHubNameListForFilter = [];
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				hubZoneId: this.hubzoneidflt1
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var listSourceHubNameListForFilter = result.data.ResponseData;
					for (i = 0; i < listSourceHubNameListForFilter.length; i++) {
						this.listSourceHubNameListForFilter.push({
							value: listSourceHubNameListForFilter[i].HubID,
							text: listSourceHubNameListForFilter[i].HubCode + ' - ' + listSourceHubNameListForFilter[i].HubName + ' (' + listSourceHubNameListForFilter[i].HubID + ')',
							text1: listSourceHubNameListForFilter[i].HubName,
							hubcode: listSourceHubNameListForFilter[i].HubCode
						})
					}
				}, error => {
					console.error(error)
				})
		},
		selectedHubZoneFlt1(hubData) {
			this.sourceHubId=''
			this.sourceHubIdArr = []
			this.listHubZoneObjDataFlt1 = hubData
			this.hubzoneidflt1 = hubData.value;
			if (this.hubzoneidflt1 != undefined) {
				this.getSourceHubNameListForFilter(this.hubzoneidflt1)
			}
		},
		getHubZoneData() {
			var self = this
			this.isLoading = true;
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					self.isLoading = false;
					var listHubZoneData = result.data.ResponseData;
					for (i = 0; i < listHubZoneData.length; i++) {
						this.listHubZoneData.push({
							value: listHubZoneData[i].hubzoneid,
							text: listHubZoneData[i].hubzonename
						})
					}
				}, error => {
					self.isLoading = false;
					console.error(error)
				})
		},
    searchBagDetails() {
					this.checkvalidation=0;
					if(this.hubzoneidflt1 ==undefined || this.hubzoneidflt1 =='')
					{
						this.HubZoneErrorForFilter="Select Hub Zone";
						this.HubZoneErrorFlg=1;
						this.checkvalidation=1;
					}

					if(this.sourceHubId ==undefined || this.sourceHubId =='' || this.sourceHubIdArr == [])
					{
						this.SourceHubErrorMsg="Select Source Hub";
						this.sourceHubIdFlg=1;
						this.checkvalidation=1;

					}
					if(this.fromdate ==undefined || this.fromdate =='')
					{
						this.fromDateError="Select From Date";
						this.checkvalidation=1;

					}
					if(this.todate ==undefined || this.todate =='')
					{
						this.toDateError="Select To Date";
						this.checkvalidation=1;

					}

					if(this.checkvalidation==1)
					{
						return false;
					}

          this.isLoading = true
          this.input = {
						FromDate:moment(this.fromdate).format('YYYY-MM-DD'),
						ToDate	:moment(this.todate).format('YYYY-MM-DD'),
						CurrentHubID:this.sourceHubId,
						PageIndex:this.pageNo,
						PageSize:this.limit
					}
					if(this.sign != undefined && this.sign != '')
					{
						this.input.Comparator =this.sign
					}
					if(this.hours != undefined && this.hours !=0)
					{
						this.input.GapHours =parseInt(this.hours)
					}
					if(this.DesHubID != undefined && this.DesHubID != '')
					{
						this.input.DestinationHubID=this.DesHubID
					}
					if(this.bagNo != null && this.bagNo != '')
					{
						this.input.BagNo=this.bagNo
					}
					if(this.bagStatus !=null && this.bagStatus != '')
					{
						this.input.BagStatus=this.bagStatus
					}
					axios({
              method: 'POST',
              url: apiUrl.api_url_hubops + 'getCurrenHubBaggingDetails',
              data: this.input,
              headers: {
                'Authorization': 'authkey xB84JJ89Hd25'
              }
            })
            .then(result => {
							this.fromDateError='';
							this.toDateError='';
							this.SourceHubErrorMsg='';
							this.sourceHubIdFlg=0;
							this.HubZoneErrorForFilter='';
							this.HubZoneErrorFlg=0;
              if (result.data.ResultCode == 100) {
                  this.showBagTable = true;
									// var hubDetails = [];
									// var logData = [];
									// for (var i = 0; i < this.hublist.length; i++) {
									// 	hubDetails[this.hublist[i].value] = this.hublist[i].text;
									// }

									// result.data.ResponseData.forEach(function(item) {
									// 	item["OriginHubName"] = '';
									// 	console.log(item.originhub,"item.OriginHubID",hubDetails[item.originhub],"hubDetails[item.OriginHubID]");
									// 	if (item.originhub && hubDetails[item.originhub]) {
									// 		item["OriginHubName"] = hubDetails[item.originhub];
									// 	}
									// 	item["CurrentLocationName"] = '';
									// 	if (item.currenthub && hubDetails[item.currenthub]) {
									// 		item["CurrentLocationName"] = hubDetails[item.currenthub];
									// 	}
									// 	item["FinalDestinationName"] = '';
									// 	if (item.destinationhub && hubDetails[item.destinationhub]) {
									// 		item["FinalDestinationName"] = hubDetails[item.destinationhub];
									// 	}
									// 	logData.push(item);
									// });
									this.bagDetails = result.data.ResponseData;

									this.totalRows=result.data.TotalCount;
									this.totalBags=result.data.TotalCount;
									if (this.totalRows < 10) {
										this.pageCount = 1
									} else {
										this.pageCount = Math.ceil(this.totalRows / 10);
									}
									this.$alertify.success(result.data.ReturnMessage)
              } else {
                this.showBagTable = false;
                this.$alertify.error(result.data.ReturnMessage)
              }
              this.isLoading = false
            },error => {
	            this.isLoading = false
	            //this.$alertify.error("Fetch Connection API error")
	            this.$alert("getCurrenHubBaggingDetails API error", "", "error");
	            console.error(error)
	          })
        //}
      //});
    },
		getCsvDetailsForBag() {
					this.checkvalidation=0;
					if(this.hubzoneidflt1 ==undefined || this.hubzoneidflt1 =='')
					{
						this.HubZoneErrorForFilter="Select Hub Zone";
						this.HubZoneErrorFlg=1;
						this.checkvalidation=1;
					}

					if(this.sourceHubId ==undefined || this.sourceHubId =='' || this.sourceHubIdArr == [])
					{
						this.SourceHubErrorMsg="Select Source Hub";
						this.sourceHubIdFlg=1;
						this.checkvalidation=1;

					}
					if(this.fromdate ==undefined || this.fromdate =='')
					{
						this.fromDateError="Select From Date";
						this.checkvalidation=1;

					}
					if(this.todate ==undefined || this.todate =='')
					{
						this.toDateError="Select To Date";
						this.checkvalidation=1;

					}

					if(this.checkvalidation==1)
					{
						return false;
					}

					this.isLoading = true
					this.input = {
						FromDate:moment(this.fromdate).format('YYYY-MM-DD'),
						ToDate	:moment(this.todate).format('YYYY-MM-DD'),
						CurrentHubID:this.sourceHubId
					}
					if(this.sign != undefined && this.sign != '')
					{
						this.input.Comparator =this.sign
					}
					if(this.hours != undefined && this.hours !=0)
					{
						this.input.GapHours =parseInt(this.hours)
					}
					if(this.DesHubID != undefined && this.DesHubID != '')
					{
						this.input.DestinationHubID=this.DesHubID
					}
					if(this.bagNo != null && this.bagNo != '')
					{
						this.input.BagNo=this.bagNo
					}
					if(this.bagStatus !=null && this.bagStatus != '')
					{
						this.input.BagStatus=this.bagStatus
					}
					this.bagDetailsForCsv=[];
					axios({
							method: 'POST',
							url: apiUrl.api_url_hubops + 'getCurrenHubBaggingDetailsForCSV',
							data: this.input,
							headers: {
								'Authorization': 'authkey xB84JJ89Hd25'
							}
						})
						.then(result => {
							this.fromDateError='';
							this.toDateError='';
							this.SourceHubErrorMsg='';
							this.sourceHubIdFlg=0;
							this.HubZoneErrorForFilter='';
							this.HubZoneErrorFlg=0;
							if (result.data.ResultCode == 100) {
									this.bagDetailsForCsv = result.data.ResponseData;
									// for(let i=0;i<this.bagDetailsForCsv.length;i++)
									// {
									// 	this.bagDetailsForCsv[i].bagcreateddate=moment(this.bagDetailsForCsv[i].bagcreateddate).format('DD-MM-YYYY HH:mm:ss')
									// 	this.bagDetailsForCsv[i].lastmodifieddate=moment(this.bagDetailsForCsv[i].lastmodifieddate).format('DD-MM-YYYY HH:mm:ss')
									// }
									// var hubDetails = [];
									// var logData = [];
									// for (var i = 0; i < this.hublist.length; i++) {
									// 	hubDetails[this.hublist[i].value] = this.hublist[i].text;
									// }

									// result.data.ResponseData.forEach(function(item) {
									// 	item["OriginHubName"] = '';
									// 	console.log(item.originhub,"item.OriginHubID",hubDetails[item.originhub],"hubDetails[item.OriginHubID]");
									// 	if (item.originhub && hubDetails[item.originhub]) {
									// 		item["OriginHubName"] = hubDetails[item.originhub];
									// 	}
									// 	item["CurrentLocationName"] = '';
									// 	if (item.currenthub && hubDetails[item.currenthub]) {
									// 		item["CurrentLocationName"] = hubDetails[item.currenthub];
									// 	}
									// 	item["FinalDestinationName"] = '';
									// 	if (item.destinationhub && hubDetails[item.destinationhub]) {
									// 		item["FinalDestinationName"] = hubDetails[item.destinationhub];
									// 	}
									// 	logData.push(item);
									// });
									this.bagDetailsForCsv = result.data.ResponseData;

									this.csvFields = {
										'bagno':'bagno',
										'bagstatus':'bagstatus',
										'originhub':'originhub',
										'destinationhub':'destinationhub',
										'currenthub':'currenthub',
										'originhubname':'originhubname',
										'currenthubname':'currenthubname',
										'destinationhubname':'destinationhubname',
										'bagtype':'bagtype',
										'cbbag':'cbbag',
										'totalchildbags':'totalchildbags',
										'totalshipments':'totalshipments',
										'shortageshipments':'shortageshipments',
										'overageshipments':'overageshipments',
										'volumetricweight':'volumetricweight',
										'physicalweight':'physicalweight',
										'chargeableweight':'chargeableweight',
										'lastmodifieddate':'lastmodifieddate',
										'lastmodifiedby':'lastmodifiedby',
										'pendinghrs':'pendinghrs',
										'routemode':'routemode',
										'bagcreateddate':'bagcreateddate',
										'bagcreatedby':'bagcreatedby'
									}

									this.jsonToCSV('Bag_Status_Report_', this.bagDetailsForCsv, this.csvFields);
									this.showBagTable = false;

									this.$alertify.success(result.data.ReturnMessage)
							} else {
								this.showBagTable = false;
								this.$alertify.error(result.data.ReturnMessage)
							}
							this.isLoading = false
						},error => {
							this.isLoading = false
							//this.$alertify.error("Fetch Connection API error")
							this.$alert("getCurrenHubBaggingDetailsForCSV API error", "", "error");
							console.error(error)
						})
				//}
			//});
		},
		jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
      var csvData = ''
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields
      for (let key in data[0]) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvfield[key] + ','
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
      //Data
      data.map(function(item) {
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            var escapedCSV = item[key] + '' // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilder.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
              else
                csvData += escapedCSV + ','
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1)
        csvData += '\r\n'
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n')
      }
      filename += moment().format('DD-MM-YYYY') + '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData
    },
    export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },

		getPaginationDataForShipment(pageNum) {
			this.pageNoForShipment = (pageNum)
			this.searchShipmentDetails()
		},
		getPaginationData(pageNum) {
			this.pageNo = (pageNum - 1)
			this.searchBagDetails()
		},
		searchShipmentDetails() {
					this.checkvalidation=0;
					if(this.hubzoneidflt1 ==undefined || this.hubzoneidflt1 =='')
					{
						this.HubZoneErrorForFilter="Select Hub Zone";
						this.HubZoneErrorFlg=1;
						this.checkvalidation=1;
					}

					if(this.sourceHubId ==undefined || this.sourceHubId =='' || this.sourceHubIdArr == [])
					{
						this.SourceHubErrorMsg="Select Source Hub";
						this.sourceHubIdFlg=1;
						this.checkvalidation=1;
					}

					if(this.fromdate ==undefined || this.fromdate =='')
					{
						this.fromDateError="Select From Date";
						this.checkvalidation=1;
					}
					if(this.todate ==undefined || this.todate =='')
					{
						this.toDateError="Select To Date";
						this.checkvalidation=1;
					}

					if(this.checkvalidation==1)
					{
						return false;
					}
					this.input = {
						fromDate:moment(this.fromdate).format('YYYY-MM-DD'),
						toDate	:moment(this.todate).format('YYYY-MM-DD'),
						currentHubID:this.sourceHubId,
						pageNo:this.pageNoForShipment,
						pageSize:this.limitForShipment
					}
					if(this.sign != undefined && this.sign != '')
					{
						this.input.comparator =this.sign
					}
					if(this.hours != undefined && this.hours !=0)
					{
						this.input.gapHours =parseInt(this.hours)
					}
					if(this.DesHubID != undefined && this.DesHubID != '')
					{
						this.input.destinationHubID=this.DesHubID
					}
					if(this.shipmentStatus != null && this.shipmentStatus != '')
					{
						this.input.shipmentStatus=this.shipmentStatus
					}
					if(this.shippingId !=null && this.shippingId != '')
					{
						this.input.shippingId=this.shippingId
					}

					this.shipmentDetails=[];
          this.isLoading = true
					axios({
						method: 'POST',
						url: apiUrl.api_url_hubops + 'getShipmentsDetailsBycurrenthubid',
						data: this.input,
              headers: {
                'Authorization': 'authkey xB84JJ89Hd25'
              }
            })
            .then(result => {
							this.fromDateError='';
							this.toDateError='';
							this.SourceHubErrorMsg='';
							this.sourceHubIdFlg=0;
							this.HubZoneErrorForFilter='';
							this.HubZoneErrorFlg=0;
              if (result.data.ResultCode == 100) {
									this.showBagTable = false;
                  this.showShipmentTable = true;
									var hubDetails = [];
									var logData = [];
									for (var i = 0; i < this.hublist.length; i++) {
										hubDetails[this.hublist[i].value] = this.hublist[i].text;
									}

									result.data.ResponseData.forEach(function(item) {
										item["OriginHubName"] = '';
										if (item.OriginHubID && hubDetails[item.OriginHubID]) {
											item["OriginHubName"] = hubDetails[item.OriginHubID];
										}
										item["CurrentLocationName"] = '';
										if (item.CurrentHubID && hubDetails[item.CurrentHubID]) {
											item["CurrentLocationName"] = hubDetails[item.CurrentHubID];
										}
										item["FinalDestinationName"] = '';
										if (item.FinalDestinationID && hubDetails[item.FinalDestinationID]) {
											item["FinalDestinationName"] = hubDetails[item.FinalDestinationID];
										}
										logData.push(item);
									});
									this.shipmentDetails = logData;

									this.totalRows=result.data.TotalShipment;
									this.totalShipments=result.data.TotalShipment;
									if (this.totalRows < 10) {
										this.pageCount = 1
									} else {
										this.pageCount = Math.ceil(this.totalRows / 10);
									}
									this.$alertify.success(result.data.ReturnMessage)
              } else {
                this.showBagTable = false;
                this.$alertify.error(result.data.ReturnMessage)
              }
              this.isLoading = false
            },error => {
	            this.isLoading = false
	            //this.$alertify.error("Fetch Connection API error")
	            this.$alert("getShipmentsDetailsBycurrenthubid API error", "", "error");
	            console.error(error)
	          })
        //}
      //});
    },

		getCsvDetailsForShipment() {
					this.checkvalidation=0;
					if(this.hubzoneidflt1 ==undefined || this.hubzoneidflt1 =='')
					{
						this.HubZoneErrorForFilter="Select Hub Zone";
						this.HubZoneErrorFlg=1;
						this.checkvalidation=1;
					}

					if(this.sourceHubId ==undefined || this.sourceHubId =='' || this.sourceHubIdArr == [])
					{
						this.SourceHubErrorMsg="Select Source Hub";
						this.sourceHubIdFlg=1;
						this.checkvalidation=1;
					}

					if(this.fromdate ==undefined || this.fromdate =='')
					{
						this.fromDateError="Select From Date";
						this.checkvalidation=1;
					}
					if(this.todate ==undefined || this.todate =='')
					{
						this.toDateError="Select To Date";
						this.checkvalidation=1;
					}

					if(this.checkvalidation==1)
					{
						return false;
					}
					this.input = {
						fromDate:moment(this.fromdate).format('YYYY-MM-DD'),
						toDate	:moment(this.todate).format('YYYY-MM-DD'),
						currentHubID:this.sourceHubId,
						pageNo:0,
						pageSize:this.limitForShipment
					}
					if(this.sign != undefined && this.sign != '')
					{
						this.input.comparator =this.sign
					}
					if(this.hours != undefined && this.hours !=0)
					{
						this.input.gapHours =parseInt(this.hours)
					}
					if(this.DesHubID != undefined && this.DesHubID != '')
					{
						this.input.destinationHubID=this.DesHubID
					}
					if(this.shipmentStatus != null && this.shipmentStatus != '')
					{
						this.input.shipmentStatus=this.shipmentStatus
					}
					if(this.shippingId !=null && this.shippingId != '')
					{
						this.input.shippingId=this.shippingId
					}

					this.shipmentDetails=[];
					this.showShipmentTable = false;
          this.isLoading = true
					axios({
						method: 'POST',
						url: apiUrl.api_url_hubops + 'getShipmentsDetailsBycurrenthubid',
						data: this.input,
              headers: {
                'Authorization': 'authkey xB84JJ89Hd25'
              }
            })
            .then(result => {
							this.fromDateError='';
							this.toDateError='';
							this.SourceHubErrorMsg='';
							this.sourceHubIdFlg=0;
							this.HubZoneErrorForFilter='';
							this.HubZoneErrorFlg=0;
              if (result.data.ResultCode == 100) {
                  this.showShipmentTable = false;

									var hubDetails = [];
									var logData = [];
									for (var i = 0; i < this.hublist.length; i++) {
										hubDetails[this.hublist[i].value] = this.hublist[i].text;
									}

									result.data.ResponseData.forEach(function(item) {
										item["OriginHubName"] = '';
										if (item.OriginHubID && hubDetails[item.OriginHubID]) {
											item["OriginHubName"] = hubDetails[item.OriginHubID];
										}
										item["CurrentLocationName"] = '';
										if (item.CurrentHubID && hubDetails[item.CurrentHubID]) {
											item["CurrentLocationName"] = hubDetails[item.CurrentHubID];
										}
										item["FinalDestinationName"] = '';
										if (item.FinalDestinationID && hubDetails[item.FinalDestinationID]) {
											item["FinalDestinationName"] = hubDetails[item.FinalDestinationID];
										}
										logData.push(item);
									});
									this.shipmentDetailsForCsv = logData;

									this.csvFields = {
										'ShippingID':'ShippingID',
										'Status':'Status',
										'ShipmentStatus':'ShipmentStatus',
										'UserProcess':'UserProcess',
										'OriginHubID':'OriginHubID',
										'CurrentHubID':'CurrentHubID',
										'FinalDestinationID':'FinalDestinationID',
										'OriginHubName':'OriginHubName',
										'CurrentLocationName':'CurrentLocationName',
										'FinalDestinationName':'FinalDestinationName',
										'CreatedDate':'CreatedDate',
										'LastModifiedBy':'LastModifiedBy',
										'LastModifiedDate':'LastModifiedDate',
										'PendingDays':'PendingDays'
									}

									this.jsonToCSV('Shipment_Status_Report_', this.shipmentDetailsForCsv, this.csvFields);
									this.showBagTable = false;

									this.$alertify.success(result.data.ReturnMessage)
              } else {
                this.showBagTable = false;
                this.$alertify.error(result.data.ReturnMessage)
              }
              this.isLoading = false
            },error => {
	            this.isLoading = false
	            //this.$alertify.error("Fetch Connection API error")
	            this.$alert("getShipmentsDetailsBycurrenthubid API error", "", "error");
	            console.error(error)
	          })
        //}
      //});
    },

		checkField() {
			this.shipmentDetailsForCsv=[],
			this.bagDetailsForCsv=[],
			this.listHubZoneObjDataFlt1= {
				value: "",
				text: ""
			},
			this.hubzoneidflt1='',
			this.listSourceHubNameListForFilter=[],
			this.listSourceHubNameDataObj3= {
				value: "",
				text: ""
			},
			this.HubZoneErrorFlg=0,
			this.sourceHubId='',
			this.sourceHubIdArr=[]
			this.sourceHubIdFlg='',
			this.listHubZoneObjDataFlt2= {
				value: "",
				text: ""
			},
			this.hubzoneidflt2='',
			this.listDestHubNameListForFilter=[],
			this.listSourceHubNameDataObj2= {
				value: "",
				text: "",
			},
			this.DesHubID='',
			this.DesHubIDArr=[]
			this.DesHubIDFlg=0,
			this.HubZoneErrorFlgForDest='',
			this.shippingId='',
			this.shippingIdError='',
			this.shipmentStatusError='',
			this.shipmentStatus='',
			this.selectedShipmentStatus= {
				value: "",
				text: ""
			},
			this.hoursError='',
			this.hours='',
		this.sign='',
		this.signError='',
		this.selectedComprator= {
			value: "",
			text: ""
		},
		this.bagStatus='',
		this.bagStatusId='',
		this.bagStausError='',
		this.bagNo='',
		this.	bagNoError=''
		this.shipmentResultData=[],
		this.checkvalidation=0
		this.fromDateError = ''
		this.toDateError = ''
    this.fromdate=''
    this.todate=''
    this.showBagTable=false
		this.shipmentDetails=[],
		this.showShipmentTable = false,
		this.selectedbagStatus= {
		value: "",
		text: ""
	},
		this.totalBags='',
		this.totalShipments=''
		this.validDateRange=''
		this.validDateRangeFrom=''
		},
    resetForm(){
      this.connectionDetails=[]
      this.csmidradio = ''
      this.thcNo = ''
      this.vehicleNo = ''
      this.ConnectionIDError = ''
      this.thcNoError = ''
      this.vehicleNoError = ''
      this.fromDateError = ''
      this.toDateError = ''
      this.fromdate=''
      this.todate=''
      this.showBagTable=false
    },
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/bagAndShipmentStatusReport/bagAndShipmentStatusReport.js